import smartsaleLogo from '../smartsale-logo.png'
import smartsaleLogoIcon from '../smartsale-logo-icon.svg'
import smartsaleOverlay from '../smartsale-overlay.svg'
import iconBlue from '../../images/dot_blue.svg'
import iconGray from '../../images/dot_gray.svg'
import iconGreen from '../../images/dot_green.svg'
import iconPurple from '../../images/dot_purple.svg'
import poweredByStripe from '../powered-by-stripe.svg'

const images = {
  iconBlue,
  iconGray,
  iconGreen,
  iconPurple,
  smartsaleLogo,
  smartsaleLogoIcon,
  smartsaleOverlay,
  poweredByStripe,
}

export { images }
